var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigures(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(-1845 -119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    transform: "translate(1868 139) rotate(-90)",
    fill: "none",
    stroke: "#36b3a1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    transform: "translate(1861 127)",
    fill: "none",
    stroke: "#36b3a1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 11,
    rx: 11.5,
    ry: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 11,
    rx: 11,
    ry: 10.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_56",
    "data-name": "Path 56",
    transform: "translate(1845 124)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,0,23,20H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.5 2.006139755249023 L 1.728530883789062 19 L 21.27146911621094 19 L 11.5 2.006139755249023 M 11.5 0 L 23 20 L 0 20 L 11.5 0 Z",
    stroke: "none",
    fill: "#36b3a1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigures);
export default __webpack_public_path__ + "static/media/figures.740608f7.svg";
export { ForwardRef as ReactComponent };